import useragent from '@finance/useragent'
import { compare } from '@common/client/src/version'
import { call, uriSuishouji } from '@common/client/src/bridge'

// 透明导航栏首页样式配置
export const TransparentBarStyle = {
  starting_offset: 0,
  end_offset: 60,
  status: 'default',
  background: {
    starting_color: '00ffffff',
    end_color: 'FFFFFFFF'
  },
  separator: {
    starting_color: '00f1f1f1',
    end_color: 'fff1f1f1'
  },
  l_item1: {
    starting_color: 'ffffffff',
    end_color: 'ff312C2C',
  },
  isFullScreen: true
}

// 透明导航头url配置
export const TransparentBarUrlConfig = JSON.stringify({
  opt: 1,
  config: TransparentBarStyle
})

// 白色导航栏内页样式配置
export const WhiteBarStyle = {
  status: 'default',
  background: {
    color: 'ffffffff'
  },
  l_item1: {
    color: 'ff000000',
  },
}

export const SuiGuanJiaTransparentStyle = {
  clientTop: true, // 默认情况false：WebView顶部与导航栏底部对齐；true:webview顶部与导航栏顶部对齐
  // 文字颜色
  starting_color: 'ffffffff', // 开始透明时文字的颜色
  end_color: 'ff000000', // 结束透明时文字的颜色
  // 背景色
  background: {
    starting_left_color: '00FFFFFF', // 开始透明时左边的渐变色
    starting_right_color: '00ffffff', // 开始透明时边的渐变色
    end_left_color: 'ffFFFFFF', // 结束透明时左边的渐变色
    end_right_color: 'ffFFFFFF', // 结束透明时右边的渐变色
  },
  // 右边第一个按钮（从右往左数）
  r_item1: {
    action: 'refresh', // 按钮动作，可以事先定好几个字符串
    text: '', // 按钮的文字，为空时显示默认图标
  },
}

// 灰色头
export const GrayBarStyle = {
  status: 'default',
  background: {
    color: 'fff2f2f2'
  },
  l_item1: {
    color: 'ff000000',
  },
}

// 白色导航头url配置
export const WhiteBarUrlConfig = JSON.stringify({
  opt: 1,
  config: WhiteBarStyle
})

// 隐藏导航头
export const HideCustomBar = {
  status: 'default',
  isHideCustomBar: true
}

// 隐藏导航头url配置
export const HideCustomBarUrlConfig = JSON.stringify({
  opt: 1,
  config: HideCustomBar
})

// 是否应用了头部导航栏设置
let isApplyBarStyle = false

const detectFeature = () => {
  // 随手记透明导航栏特性版本号
  const SUISHOUJI_IOS = '10.8.7'
  const SUISHOUJI_ANDROID = '10.4.5.0'

  if (useragent.isIOS) {
    if (useragent.isSuishouji) {
      return compare(SUISHOUJI_IOS)
    }
    if (useragent.isKaniu) {
      return false
    }
  }
  if (useragent.isAndroid) {
    if (useragent.isSuishouji) {
      return compare(SUISHOUJI_ANDROID)
    }
    if (useragent.isKaniu) {
      return false
    }
  }
  return false
}
export const canApplyBarStyle = detectFeature()

// 禁止卡牛下拉刷新
export const disabledKnPullRefresh = () => {
  if (useragent.isKaniu) {
    call('cardniu://app/webview/config?isCanPullRefresh=false')
  }
}

export default ({ cancel = false, needKaniu = false, barStyle = {} } = {}) => {
  if (!canApplyBarStyle) {
    return
  }
  if (cancel) {
    if (isApplyBarStyle) {
      isApplyBarStyle = false
      if (useragent.isKaniu && needKaniu) {
        call('cardniu://finance/barStyle?opt=0')
      } else if (useragent.isSuishouji) {
        call(uriSuishouji('barStyle', { opt: 0 }))
      }
    }
    return
  }

  if (useragent.isKaniu && needKaniu) {
    isApplyBarStyle = true
    call(`cardniu://finance/barStyle?opt=1&config=${encodeURIComponent(JSON.stringify(barStyle))}`)
  } else if (useragent.isSuishouji) {
    isApplyBarStyle = true
    call(uriSuishouji('barStyle', { opt: 1, config: barStyle }))
  }
}
